export { LayerBox } from './LayerBox';

// Fix me: Missing theme handling
export const THEME_COLOR = '#006ce8';
